import { render, staticRenderFns } from "./MaterialInputCard.vue?vue&type=template&id=a87c70e2&scoped=true&"
import script from "./MaterialInputCard.vue?vue&type=script&lang=js&"
export * from "./MaterialInputCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialInputCard.vue?vue&type=style&index=0&id=a87c70e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a87c70e2",
  null
  
)

/* custom blocks */
import block0 from "./MaterialInputCard.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports